import { render, staticRenderFns } from "./changeOwnershipByVehicleCategory.vue?vue&type=template&id=b50a9010&"
import script from "./changeOwnershipByVehicleCategory.vue?vue&type=script&lang=js&"
export * from "./changeOwnershipByVehicleCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports